<div class="text-lg font-semibold border-bottom-2 border-cyan-500 mb-2">Rufnummernmitnahme</div>
<ng-container *ngIf="portingData.porting">
    Rufnummern: {{ portingNumbers }}<br />
    Aktueller Anbieter: {{ portingData.provider }}<br />
    <ng-container [ngSwitch]="portingData.owner">
        <ng-container *ngSwitchCase="'customer'">
            Anschlussinhaber: Wie Auftraggeber<br />
        </ng-container>
        <ng-container *ngSwitchCase="'billing'">
            Anschlussinhaber: Rechnungsanschrift<br />
        </ng-container>
        <ng-container *ngSwitchCase="'other'">
            Anschlussinhaber:<br />
            {{ portingData.title }} {{ portingData.firstName }} {{ portingData.lastName }}<br />
            {{ portingData.streetName }} {{ portingData.streetNumber }}<br />
            {{ portingData.postalCode }} {{ portingData.city }}<br />
        </ng-container>
    </ng-container>
</ng-container>
<ng-container *ngIf="!portingData.porting">
    keine Rufnummernmitnahme<br />
</ng-container>
